import { render, staticRenderFns } from "./supportCenter.html?vue&type=template&id=47d01ef2&scoped=true&"
import script from "./supportCenter.js?vue&type=script&lang=js&"
export * from "./supportCenter.js?vue&type=script&lang=js&"
import style0 from "./supportCenter.scss?vue&type=style&index=0&id=47d01ef2&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=47d01ef2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d01ef2",
  null
  
)

export default component.exports